var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "aria-live": "polite", "aria-label": "Notifications area" } },
    [
      _vm.isLogged
        ? _c(
            "v-menu",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isLogged,
                  expression: "isLogged",
                },
              ],
              attrs: {
                "close-on-content-click": false,
                "nudge-width": 200,
                transition: "slide-y-transition",
                bottom: "",
                "offset-x": "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function (ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                attrs: {
                                  icon: "",
                                  "aria-label": _vm.$t(
                                    "components.notifications.tooltip"
                                  ),
                                  "aria-expanded": _vm.notficationsDropDown,
                                  "aria-haspopup": "true",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.notificationsVisibility()
                                  },
                                },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _c(
                              "v-badge",
                              {
                                attrs: {
                                  color: "accent",
                                  centered: "",
                                  right: "",
                                  overlap: "",
                                  value: _vm.notificationsList.length > 0,
                                  "aria-label":
                                    "Unread {{ notificationsList.length }}",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "badge",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(
                                                _vm.notificationsList.length ||
                                                  0
                                              ) +
                                              "\n          "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var tooltipOn = ref.on
                                            var tooltipAttrs = ref.attrs
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        medium: "",
                                                        color: "white",
                                                        "aria-hidden": "true",
                                                      },
                                                    },
                                                    "v-icon",
                                                    tooltipAttrs,
                                                    false
                                                  ),
                                                  tooltipOn
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                fal fa-bell\n              "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "components.notifications.tooltip"
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                4155433027
              ),
              model: {
                value: _vm.notficationsDropDown,
                callback: function ($$v) {
                  _vm.notficationsDropDown = $$v
                },
                expression: "notficationsDropDown",
              },
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                {
                  attrs: {
                    role: "menu",
                    "aria-label": "Notifications menu",
                    width: "320",
                  },
                },
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            { staticClass: "text-uppercase" },
                            [
                              _c(
                                "v-list-item-title",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        size: "20",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                fal fa-bell\n              "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "h6 font-weight-thin" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "components.notifications.title"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c("v-progress-linear", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isLoading,
                        expression: "isLoading",
                      },
                    ],
                    attrs: {
                      color: "accent",
                      indeterminate: "",
                      "aria-label": "Loading",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.notificationsList.length
                    ? _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "18",
                                            "aria-hidden": "true",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                fal fa-empty-set\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-thin" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "components.notifications.contentless"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    _vm._l(_vm.notificationsList, function (notification) {
                      return _c(
                        "v-list-item",
                        _vm._b(
                          {
                            key: notification.id,
                            staticClass: "notification pb-1 pt-1",
                            attrs: { "active-class": "notification", link: "" },
                          },
                          "v-list-item",
                          notification.navigateTo,
                          false
                        ),
                        [
                          _c(
                            "v-list-item-avatar",
                            { attrs: { size: "25" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: notification.iconColor,
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s("fad fa-" + notification.icon) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          notification.message
                            ? _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(notification.message) +
                                        "\n            "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", {
                                    staticClass: "text-subtitle-1",
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.toReadableDate(
                                          notification.created_at
                                        )
                                      ),
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    small: "",
                                    color: "white",
                                    "aria-label": "Delete",
                                    tabindex: "0",
                                    role: "button",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.markNotification(
                                        notification.id
                                      )
                                    },
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.markNotification(
                                          notification.id
                                        )
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "space",
                                            32,
                                            $event.key,
                                            [" ", "Spacebar"]
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.markNotification(
                                          notification.id
                                        )
                                      },
                                    ],
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              fal fa-trash\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _vm.notificationsList.length
                    ? _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                text: "",
                                color: "secondary",
                                "aria-label": _vm.$t(
                                  "components.notifications.buttons.clear"
                                ),
                              },
                              on: { click: _vm.clearNotifications },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.notifications.buttons.clear"
                                    )
                                  ) +
                                  "\n        "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }